<template>
<v-app>
<resizable-page>
  <template v-slot:table="tableProps">
  <v-card>
    <v-card-title>
      <v-select
          :items="options_brands"
          label="Brands"
          v-model="brand_id"
          v-on:change="onChangeBrand"
           item-text="vehicle_brand_name"
          item-value="id"
          single-line
          class="ma-2"
        hide-details
        >
        </v-select>
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Search"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>
    <v-data-table
      mobile-breakpoint
      :headers="headers"
      :items="table"
      :search="search"
      :loading="loadTable"
      loading-text="Loading... Please wait"
      ref="vTable"
      :height="tableProps.tableHeight"
      fixed-header
      :footer-props="{'items-per-page-options':[5,15, 30, 50, 100]}"
    >
    <template v-slot:item="{ item }">
        <tr  @click="onSelect(item)">
            <td>{{item.vehicle_model}}</td>
            <td>{{item.vehicle_year_model}}</td>
            
        </tr>
    </template>
    
    </v-data-table>
  </v-card>
    </template>
  </resizable-page>
  </v-app>
</template>

<script>
import vuetify from '@/plugins/vuetify'
import { ResizablePage } from "@/components";

  export default {
    vuetify,
    components: {ResizablePage
  },
     props: {
    data_id: null,
    },
    data () {
      return {
        options_brands: null,
        brand_id: null,
        loadTable: true,
        search: '',
        headers: [
          { text: 'Vehicle Model', value: 'vehicle_model' },
          { text: 'Vehicle Model Year', value: 'vehicle_year_model' },
        ],
        table: [],
      }
    },
    async created() {
      
    this.getList();
    },
     methods: {
       // ambil data yang dibutuhkan
    async getList() { 
      
      
      await this.$store.dispatch("workshop_vehicle_brand/list")
      this.options_brands = await this.$store.getters["workshop_vehicle_brand/list"]
      this.loadTable= false
    },



    //fungsi yang ada di parent di panggil saat memilih row di table
    onSelect (item) {
    // this.$parent.$parent.modalCloseList(item,this.options_brands[index].vehicle_brand_name)
     var index = this.options_brands.findIndex(p => p.id ==  this.brand_id)
      this.$parent.$parent.$parent.modalCloseListVehicleType(item,this.options_brands[index].vehicle_brand_name)
      },

      async onChangeBrand(){
      this.loadTable= true
      await this.$store.dispatch("workshop_vehicle_type/listByBrand",this.brand_id)
      //check respon list data dari server apakah null?
      this.table = await this.$store.getters["workshop_vehicle_type/vehicle_type"]
      this.loadTable= false

    },

     },

     
  }
</script>
<style>
.v-application--wrap {
  min-height: unset;
}
.v-list-item__title {
    font-size: 0.8rem;
}
.v-menu__content{
    z-index: 10 !important;
}
table > tbody > tr > td.fixed:nth-child(1), 
  table > thead > tr > th.fixed:nth-child(1) {
    position: sticky !important; 
    position: -webkit-sticky !important; 
    left: 0; 
    z-index: 9998;
    background: white;
  }
  table > thead > tr > th.fixed:nth-child(1) {
    z-index: 9999;
  }
</style>